
import {SourceSup} from 'components/sources'
import CollapsedMdTable from './collapsed-md-table.vue'
import ExternalLink from './external-link.vue'

export default {
  components: {SourceSup, ExternalLink, CollapsedMdTable},
  props: {
    nodes: {
      type: NodeList, required: true
    },
    restricted: {
      type: Boolean, default: false
    }
  },
  computed: {
    processed_nodes(){
      let result = []
      this.nodes.forEach((n, i) => {
        const item = {node: n}
        if (n.nodeType === Node.ELEMENT_NODE) {

          if (n.tagName === 'BUTTON') {
            if (n.attributes) {
              const btn_type = n.attributes.getNamedItem('type')
              if (btn_type.value === 'inline') {
                const btn_click = n.attributes.getNamedItem('click')
                return result.push({
                  ...item,
                  type: 'button',
                  text: n.innerText,
                  click: +btn_click.value
                })
              }
            }
          }

          if (n.tagName === 'A') {
            const num = +n.querySelector('sup')?.innerText
            if (num) {
              return result.push({
                ...item,
                type: 'source', content: num
              })
            }
            else {
              return result.push({
                ...item,
                type: 'external-link',
                href: n.href
              })
            }
          } 


          if (n.tagName === 'TABLE') {
            let title = undefined
            const prev = result.findLast(n => n.type === 'parent' && ['H2', 'H3', 'P'].includes(n.name))
            if (prev) {
              title = prev
              result = result.filter(n => n !== title)
            }
            return result.push({
              ...item,
              type: 'table', content: n.childNodes, title
            })
          } 
        }


        const attributes = {}
        for (let attr of n.attributes || []) {
          if (attr.name === 'href') continue
          attributes[attr.name] = attr.value
        }

        const parent = n.childNodes?.length > 0
        return result.push({
          ...item,
          type: parent ? 'parent' : undefined,
          content: parent ? n.childNodes : (n.innerHtml || n.textContent),
          name: n.tagName,
          attributes
        })
      })
      return result
    }
  }
}
